<section id="cta" data-home-cta class="bg-emerald-700 py-6 md:py-8">
  <div class="mx-auto grid max-w-7xl gap-6 px-4 lg:grid-cols-2 lg:items-center">
    <div class="min-w-0">
      <p class="text-xs font-semibold uppercase text-emerald-50">
        Xe điện · Máy nông nghiệp
      </p>
      <h2 class="mt-1 text-2xl font-bold text-white">
        {{ content.heading }}
        <span>{{ content.highlightedHeading }}</span>
      </h2>
      <p class="mt-2 text-sm text-emerald-50">{{ content.description }}</p>

      <div class="mt-4 flex flex-wrap gap-3">
        <a
          data-contact="phone"
          [href]="'tel:' + content.phone"
          class="inline-flex items-center gap-2 rounded-md bg-white px-4 py-2 text-emerald-700 hover:bg-emerald-50"
        >
          <mat-icon svgIcon="hero:phone"></mat-icon>
          <span class="flex flex-col leading-tight">
            <small class="text-xs text-slate-600">{{ content.phoneButtonLabel }}</small>
            <strong class="text-sm">{{ content.phone }}</strong>
          </span>
        </a>
        <a
          data-contact="email"
          [href]="'mailto:' + content.email"
          class="inline-flex items-center gap-2 rounded-md border border-white px-4 py-2 text-white hover:bg-emerald-800"
        >
          <mat-icon svgIcon="hero:mail"></mat-icon>
          <span class="flex flex-col leading-tight">
            <small class="text-xs text-emerald-50">{{ content.emailButtonLabel }}</small>
            <strong class="break-all text-sm">{{ content.email }}</strong>
          </span>
        </a>
      </div>
    </div>

    <aside class="grid gap-2 text-white" aria-label="Thông tin liên hệ">
      <div data-contact-detail class="flex items-start gap-2">
        <mat-icon class="flex-none" svgIcon="hero:schedule"></mat-icon>
        <div class="text-sm"><small class="block text-emerald-50">{{ content.workingHoursLabel }}</small><strong>{{ content.workingHoursValue }}</strong></div>
      </div>
      <div data-contact-detail class="flex items-start gap-2">
        <mat-icon class="flex-none" svgIcon="hero:place"></mat-icon>
        <div class="text-sm"><small class="block text-emerald-50">{{ content.addressLabel }}</small><strong>{{ content.addressValue }}</strong></div>
      </div>
      <div data-contact-detail class="flex items-start gap-2">
        <mat-icon class="flex-none" svgIcon="hero:headset_mic"></mat-icon>
        <div class="text-sm"><small class="block text-emerald-50">{{ content.supportLabel }}</small><strong>{{ content.supportValue }}</strong></div>
      </div>
    </aside>
  </div>
</section>
